export default __webpack_public_path__ + "static/media/blog4.4743db66.jpg";